import vue from '../main'
import axios from 'axios'

// for action links
const url = 'https://dripassist.freshdesk.com/api/v2/tickets'
const headers = {
  Authorization: `Basic ${btoa('DVqme3XHKC4JEiGUklcL')}`,
  'Content-Type': 'application/json'
}
const name = vue.$store.getters.user && vue.$store.getters.user.name
const email = vue.$store.getters.user && vue.$store.getters.user.email

const createTicket = (data = {}, cfCategory, cfQuestion) => {
  const account =
    (vue.$store.state.account && vue.$store.state.account.account) || {}
  const adminLink = `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/importers/${data.item.importer_user_id}/clients/${data.item.id}`

  return axios({
    url: url,
    method: 'post',
    headers: headers,
    data: {
      name: name,
      email: email,
      description: `${cfCategory} - ${cfQuestion} - ${adminLink} - Action Link`,
      subject: `Support Ticket | ${data.item.importer} | Drip Capital`,
      priority: 1,
      status: 2,
      custom_fields: {
        cf_exporter_id: account.id,
        cf_exporter_name: account.company,
        cf_importer_id: data.item.importer_user_id,
        cf_importer_name: data.item.importer,
        cf_client_id: data.item.id,
        cf_link_to_dashboard: adminLink,
        cf_am_email: (account.am && account.am.email) || '',
        cf_cs_email: (account.cs && account.cs.email) || '',
        cf_category_i: cfCategory,
        cf_question_i: cfQuestion,
        cf_query_channel: 'Portal',
        cf_portal_source: 'RF Portal',
        cf_spam:
          process.env.VUE_APP_ENVIRONMENT === 'production' ? 'Non Spam' : 'Spam'
      }
    }
  })
}

const createInvoiceTicket = (data = {}, cfQuestion, description) => {
  const account =
    (vue.$store.state.account && vue.$store.state.account.account) || {}
  const adminLink = `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/invoices/${data.id}`

  return axios({
    url: url,
    method: 'post',
    headers: headers,
    data: {
      name: name,
      email: email,
      description: `Invoice related - ${cfQuestion} - ${description} - ${adminLink} - Action Link`,
      subject: `Support Ticket | ${data.reference} | Drip Capital`,
      priority: 1,
      status: 2,
      custom_fields: {
        cf_exporter_id: account.id,
        cf_exporter_name: account.company,
        cf_importer_id: data.importer_user_id,
        cf_importer_name: data.importer,
        cf_client_id: data.client_id,
        cf_invoice_id: data.id,
        cf_invoice_reference: data.reference,
        cf_link_to_dashboard: adminLink,
        cf_am_email: account.am.email || '',
        cf_cs_email: account.cs.email || '',
        cf_category_i: 'Invoice related',
        cf_question_i: cfQuestion,
        cf_query_channel: 'Portal',
        cf_spam:
          process.env.VUE_APP_ENVIRONMENT === 'production'
            ? 'Non Spam'
            : 'Spam',
        cf_portal_source: 'RF Portal' // request source
      }
    }
  })
}

export default {
  createTicket,
  createInvoiceTicket
}
